import React from 'react'
import HighlightStyles from './InvestmentHighlights.module.css'
import { Box, Button, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import IconButton from '@mui/material/IconButton';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import { useState } from 'react';
import axios from 'axios';
import { useEffect } from 'react';


// import this for redux read write
import { useSelector, useDispatch } from 'react-redux'
import { setNotifications } from '../../state/GlobalState'
import { setNotificationCount } from '../../state/GlobalState'


import DeleteConformation from '../DeleteConformation/DeleteConformation';
import useToast from '../../hooks/useToast';
import useBackdrop from '../../hooks/useBackdrop/useBackdrop';

const InvestmentHighlights = () => {

    // get data from redux
    const name = useSelector((state) => state.globalData.name);
    const count = useSelector((state) => state.globalData.notificationCount);
    const dispatch = useDispatch()
    const [tempData, setTempData] = useState(null);
    const { Toast, showToast } = useToast();
    const { openBackdrop, closeBackdrop, BackdropComponent } = useBackdrop();

    const [data, setData] = useState([])

    const getHighlightsData = async () => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_COSMOSADMIN}/investmentHighlights/getAllInvestmentHighlights`
            )
            setData(res.data)
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getHighlightsData()
    }, [])


    const handleDeleteHighlight = async () => {
        try {
            const res = await axios.delete(
                `${process.env.REACT_APP_COSMOSADMIN}/investmentHighlights/deleteById/${tempData.logoId}`
            ).then((res) => {
                showToast("success", "highlight Delete Successfully");
                handleDeleteModal();
                getHighlightsData();
            })

            

            dispatch(setNotificationCount({
                count: count + 1,
            }))

        } catch (error) {
            console.log(error)
        }
    }


    const [deleteModal, setDeleteModal] = useState(false);

    const handleDeleteModal = (data) => {
        setDeleteModal(prev => !prev)
        if (data !== undefined && data !== "" && data !== null) {
            setTempData(data)
        }
    }
    return (
        <>
            <Toast />
            <useBackdrop />
            <div className={HighlightStyles.highlightMain}>
                <div className={HighlightStyles.highlightContent}>
                    <div className={HighlightStyles.highlightHeader}>
                        <Typography sx={{ marginTop: '1%', color: '#121926', fontWeight: '600', fontSize: '20px' }} >
                            Investment Highlights
                        </Typography>
                        <Link to='/addinvestment'>
                            <Button sx={{ textTransform: 'capitalize' }} variant='contained'>Add Highlight</Button>
                        </Link>
                    </div>
                    <Box className={HighlightStyles.highlightComponent}>
                        <div className={HighlightStyles.highlightComponentLeft}>
                            <Typography variant='h5' sx={{ fontSize: '15px', fontWeight: '600' }}>
                                Name
                            </Typography>
                        </div>
                        <div className={HighlightStyles.highlightComponentRight}>
                            <Typography variant='h6' sx={{ fontSize: '15px', fontWeight: '600' }}>
                                Last modified
                            </Typography>
                            <Typography variant='h6' sx={{ fontSize: '15px', fontWeight: '600' }}>
                                Action
                            </Typography>
                        </div>
                    </Box>
                    {data.map((highlight) =>
                        <Box className={HighlightStyles.highlightComponent}>
                            <div className={HighlightStyles.highlightComponentLeft}>
                                <Typography variant='h5' sx={{ fontSize: '15px', fontWeight: '600' }}>
                                    {highlight.highlights?.investmentHeader}
                                </Typography>
                            </div>
                            <div className={HighlightStyles.highlightComponentRight}>
                                <Typography variant='h6' sx={{ fontSize: '15px' }}>
                                    {highlight.highlights?.date}
                                </Typography>
                                <Typography variant='h6' sx={{ fontSize: '15px', fontWeight: '600', display: 'flex', alignItems: 'baseline' }}>
                                    <Link to={`/editinvestment/${highlight?.logoId}`} state={highlight}>
                                        <BorderColorOutlinedIcon sx={{ color: '#16469d', cursor: 'pointer' }} />
                                    </Link>
                                    <IconButton disableRipple onClick={() => handleDeleteModal(highlight)}>
                                        <DeleteForeverOutlinedIcon sx={{ color: '#16469d', cursor: 'pointer' }} />
                                    </IconButton>
                                </Typography>
                            </div>
                        </Box>
                    )}
                </div>
            </div>


            <DeleteConformation
                onClose={handleDeleteModal}
                open={deleteModal}
                onConfirm={() => handleDeleteHighlight()}
                onReject={() => { }}
            >
                <h2>Delete Our Highlight</h2>
                <p>Are you sure you want to Delete this Highlight?</p>

            </DeleteConformation>
        </>

    )
}

export default InvestmentHighlights